export default function Hamburger({ isSidebarExpanded, toggleSidebarExpand }: { isSidebarExpanded: boolean; toggleSidebarExpand: () => void }) {
  return (
    <button
      type="button"
      onClick={toggleSidebarExpand}
      className="mb-[0.625rem] flex flex-col items-center justify-center lg:!hidden"
      aria-label={isSidebarExpanded ? "Close menu" : "Open menu"}
      aria-expanded={isSidebarExpanded}
    >
      <span
        className={`block h-0.5 w-6 rounded-sm bg-white 
                    transition-all duration-300 ease-out ${
                      isSidebarExpanded
                        ? "translate-y-1 rotate-45"
                        : "-translate-y-0.5"
                    }`}
      ></span>
      <span
        className={`my-0.5 block h-0.5 w-6 rounded-sm 
                    bg-white transition-all duration-300 ease-out ${
                      isSidebarExpanded ? "opacity-0" : "opacity-100"
                    }`}
      ></span>
      <span
        className={`block h-0.5 w-6 rounded-sm bg-white 
                    transition-all duration-300 ease-out ${
                      isSidebarExpanded
                        ? "-translate-y-1 -rotate-45"
                        : "translate-y-0.5"
                    }`}
      ></span>
    </button>
  );
}
